export const isOpen = state => state.eulaReducer.prompt.open //
export const wasAccepted = state => state.eulaReducer.prompt.accepted //
export const getAcceptText = state => state.eulaReducer.prompt.acceptText
export const getDeclineText = state => state.eulaReducer.prompt.declineText
export const getUserId = state => state.eulaReducer.prompt.userId
export const isNewEula = state => state.eulaReducer.prompt.newEula
export const shouldOpenOnFetch = state => state.eulaReducer.prompt.openOnFetch



// WEBPACK FOOTER //
// ./src/features/Eula/data/prompt/selectors.js